

























import { Vue, Component, Prop } from "vue-property-decorator";
import CallPhone from "@/pages/showDetail/CallPhone.vue";

@Component({
  components: {
    "call-phone": CallPhone
  }
})
export default class LessonTypeList extends Vue {
  @Prop({ required: true }) dataList!: Array<object>;
}
